import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowNoContracts() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.no-contracts')}
      description={t('feature-description.no-contracts')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
